import type { UploadFile } from '@x7web/tcom-ui'
import { md5 } from 'js-md5'

function encrypt(obj: any) {
  const private_key = import.meta.env.VITE_REQ_HEADERS_ENCRYPT_PRIVATE_KEY

  const newObj = obj
  newObj.private_key = private_key
  const resSortObj = sortObj(newObj)
  const str = convertObj(resSortObj)
  const md5Str = md5(str)
  delete newObj.private_key
  newObj.sign = md5Str
  const resStr = convertObj(newObj)
  return resStr
}

// 将对象转换成a=1&b=2这种格式，主要用于加密
function convertObj(obj: any) {
  const arr: string[] = []
  Object.keys(obj).forEach(function (item) {
    arr.push(item + '=' + obj[item])
  })
  return arr.join('&')
}

// 对对象按key进行排序，只有一层的对象
function sortObj(obj: any) {
  const sortObj: { [key: string]: any } = {}
  Object.keys(obj)
    .sort()
    .forEach((item) => {
      sortObj[item] = obj[item]
    })
  return sortObj
}

/**
 * @description 获取上传文件的id
 * @param {UploadFile[]} files 上传文件列表
 * @returns {string} 返回上传文件的id
 */

function getUploadIdsToStr(files: UploadFile[]): string {
  return files.map((item) => item.response?.uploadId)?.join(',')
}

/**
 * @description 获取字符串字节数长度
 * @param {string} str 字符串
 */
function getByteLength(str: string) {
  let count = 0
  const arr = str.split('')
  arr.forEach((item: any) => {
    count += Math.ceil(item.charCodeAt().toString(2).length / 8)
  })
  return count
}

/**
 * @description 获取短横线"-"前面的字符串
 * @param {string} str 传入的字符串
 * @returns {string} 返回短横线"-"前面的字符串
 */
export const getBeforeDash = (str: string): string => {
  const index = str.indexOf('-')
  if (index !== -1) {
    return str.slice(0, index)
  }
  return str
}

export { encrypt, getUploadIdsToStr, getByteLength }
